export const WIDGET_BUBBLES_ALIGMENT = 'right'; // 'left' or 'right'

export const WIDGET_BUTTON_POSITION = '30px,20px';

export const WIDGET_BUTTON_SIZE = '56px';

export const USE_MOCK_CHAT = true; // Set to false to use real Salesforce MIAW API

export const LEGAL_ACCEPTED_STORAGE_KEY = 'chat-widget-legal-accepted';

export const FLOATING_BUTTONS_DISMISSED_KEY = 'chat-floating-buttons-dismissed';
